import { Link } from 'react-router-dom';
import { ArrowLeft, Search } from 'lucide-react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { Button } from '../components/ui/button';
import { useDocumentTitle } from '../hooks/use-document-title';

export default function NotFoundPage() {
  useDocumentTitle('Page not found');

  return (
    <div className="min-h-screen flex flex-col bg-paper paper-texture">
      <Navbar />
      <main id="main-content" className="flex-1 flex items-center justify-center px-4 sm:px-6 pt-32 pb-20">
        <div className="text-center max-w-lg">
          <p className="font-script text-6xl sm:text-7xl text-gold mb-2">Oops</p>
          <h1 className="font-serif text-3xl sm:text-4xl font-bold text-ink mb-3">We couldn't find that page</h1>
          <p className="text-ink/60 mb-8">
            The link may be broken or the page may have moved. Let's get you back to planning your simcha.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button asChild className="bg-gold text-white hover:bg-gold/90">
              <Link to="/templates">
                <Search className="h-4 w-4" />
                Browse templates
              </Link>
            </Button>
            <Button asChild variant="outline">
              <Link to="/">
                <ArrowLeft className="h-4 w-4" />
                Back to home
              </Link>
            </Button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
